import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { SuccessPath, UpdatePathMutationArgs } from '../../dto';
import { pathFrag } from './fragments';

type Result = { updatePath: SuccessPath };
type Variables = UpdatePathMutationArgs;
export function useUpdatePath(options?: MutationHookOptions<Result, Variables>) {
  const mutation = gql`
    ${pathFrag}
    mutation updatePath($input: PathInput!, $renderTemplateData: Boolean) {
      updatePath(input: $input, renderTemplateData: $renderTemplateData) {
        ...pathFrag
      }
    }
  `;

  return useMutation<Result, Variables>(mutation, options);
}

export default useUpdatePath;
